import * as XLSX from 'xlsx';
import { showDate, showTime } from 'src/constants';

export const processArray = (array) => {
  if (array.length < 2) {
    return null;
  }
  if (
    array[0].lat === null ||
    array[0].lng === null ||
    array[array.length - 1].lat === null ||
    array[array.length - 1].lng === null
  ) {
    return null;
  }

  const origin = array[0];
  const destination = array[array.length - 1];
  const inBetweenArray = array.slice(1, array.length - 1);

  return {
    origin: origin,
    destination: destination,
    inBetweenArray: inBetweenArray,
  };
};

export const calculatePrice = (distance, pricingData, marketing, lessThanThreeItems, noOfStops) => {
  const { noOfFreeMiles, priceOfBaseCharge, priceOfPerMile, acceptMarketing, extraStopCharge, threeItems } =
    pricingData;

  const perMileChargeDistance = Math.max(distance - noOfFreeMiles, 0);
  console.log(threeItems, priceOfBaseCharge, perMileChargeDistance, priceOfPerMile);
  let price = priceOfBaseCharge + perMileChargeDistance * priceOfPerMile;

  if (noOfStops > 2) {
    price += extraStopCharge * (noOfStops - 2);
  }

  if (lessThanThreeItems === 'yes') {
    price -= price * (threeItems / 100);
  }

  if (marketing) {
    price *= 1 - acceptMarketing / 100;
  }

  return price.toFixed(2);
};

export const getOrdinal = (n) => {
  const s = ['th', 'st', 'nd', 'rd'];
  const v = n % 100;
  return n + (s[(v - 20) % 10] || s[v] || s[0]);
};

export const transformDataToCSV = (data) => {
  const modifiedData = data.data.rows.map((item) => ({
    Email: item.email,
    Phone: item.phoneNumber,
    'First Name': item.firstName,
    'Last Name': item.lastName,
    Status: item.status,
    Description: item.itemDescription,
    'People In Van': item.peopleInVan?.toString(),
    'Loader In Van': item.loaderInVan?.toString(),
    'Other Information': item.otherInformation,
    'Learn About Us': item.hearAboutUs,
    'Start Date': showDate(item.dateTime),
    'Start Time': showTime(item.dateTime),
    'Created Date': showDate(item.createdAt),
    'Created Time': showTime(item.createdAt),
    'Distance (miles)': item.distance?.toString() + ' miles',
    Price: item.price?.toString() + ' £',
    'Accept Marketing': item.acceptMarketing?.toString(),
    'Start Point': item.startPoint?.address,
    'Middle Points': item.middlePoints?.map((a) => a.address).join('\n'),
    'End Point': item.endPoint?.address,
  }));
  const ws = XLSX.utils.json_to_sheet(modifiedData);
  ws['!cols'] = [
    { width: 25 },
    { width: 15 },
    { width: 15 },
    { width: 15 },
    { width: 10 },
    { width: 50 },
    { width: 15 },
    { width: 15 },
    { width: 40 },
    { width: 15 },
    { width: 12 },
    { width: 10 },
    { width: 12 },
    { width: 10 },
    { width: 10 },
    { width: 10 },
    { width: 15 },
    { width: 30 },
    { width: 30 },
    { width: 30 },
  ];
  const headerRow = 1;
  const range = XLSX.utils.decode_range(ws['!ref']);
  for (let col = range.s.c; col <= range.e.c; col++) {
    const cellAddress = XLSX.utils.encode_cell({ r: headerRow, c: col });
    if (ws[cellAddress]) {
      const cell = ws[cellAddress];
      cell.s = { font: { bold: true } };
    }
  }
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
  XLSX.writeFile(wb, 'Bookings.xlsx');
};
